<div class="row custom_header">
    <div class="col-sm-2"><button class="btn btn-outline-info btn-block">Créer/Modifier</button></div>
    <div class="col-sm-2"><button class="btn btn-outline-info btn-block">Effacer</button></div>
</div>
<table class="table table-bordered table-sm" id="en_service">
    <thead>
        <th (click)="sortby('nom')" scope="col">Nom installation</th>
        <th (click)="sortby('societe')" scope="col">Société</th>
        <th (click)="sortby('codep')" scope="col">Code Postal</th>
        <th (click)="sortby('adresse')" scope="col">Adresse</th>
        <th (click)="sortby('pays')" scope="col">Pays</th>
        <th (click)="sortby('statut')" scope="col">Statut</th>
    </thead>
    <tbody>
        <!-- Cette fonction n'est certainement plus utilisée 
        30/08/2021 - EBS
        -->
    </tbody>
</table>
